import { render, staticRenderFns } from "./taxPayerSystem.vue?vue&type=template&id=0eae874a&scoped=true&"
import script from "./taxPayerSystem.vue?vue&type=script&lang=js&"
export * from "./taxPayerSystem.vue?vue&type=script&lang=js&"
import style0 from "./taxPayerSystem.vue?vue&type=style&index=0&id=0eae874a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eae874a",
  null
  
)

export default component.exports